export default __webpack_public_path__ + "static/media/iResponsiveOTSPFullSize.4bbeffa4.png";